var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view credit-control-save" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "5122",
                "custom-sim-query-placeholder":
                  _vm.$t("advanceSearchForm.quickSearch") +
                  ":" +
                  _vm.$t("Partners.parter"),
                "expand-adv": true,
                "custom-search-items": _vm.customSearchItems,
                "auto-init": _vm.searchItemAutoInit
              },
              on: { query: _vm.toQuery }
            },
            [
              _vm.showPartnerButton
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _vm.$checkPermission(["write_SMPartner"]) &&
                      !_vm.showIfRisk
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "toNew", type: "primary" },
                              on: { click: _vm.toNew }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.add")))]
                          )
                        : _vm._e(),
                      (_vm.$store.getters.isAdmin ||
                        _vm.$checkPermission([
                          "button_SMPartner_deletePartner"
                        ])) &&
                      !_vm.showIfRisk
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "toDelete", type: "danger" },
                              on: { click: _vm.toDelete }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.delete")))]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "toLook", type: "primary" },
                          on: { click: _vm.toLook }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.view")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "toCommit", type: "primary" },
                          on: { click: _vm.toCommit }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
                      ),
                      _vm.auditBtnPermission
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "toAudit", type: "primary" },
                              on: { click: _vm.toAudit }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.review")))]
                          )
                        : _vm._e(),
                      _vm.cancelAuditBtnPermission
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "toCancelAudit", type: "primary" },
                              on: { click: _vm.toCancelAudit }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_CancelAudit"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["button_SMPartner_printPartner"])
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "toPrint", type: "primary" },
                              on: { click: _vm.toPrint }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.batchPrint")))]
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["button_SMPartner_openB2B"])
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "toInviteB2B", type: "primary" },
                              on: { click: _vm.toInviteB2B }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Partners.B2BRegistrationInvitation")
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_SMPartner_authorizationPrice"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "toGrantPriceLevel",
                                type: "primary"
                              },
                              on: { click: _vm.toGrantPriceLevel }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Partners.freightAuthorization"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["button_SMPartner_mergePartner"]) &&
                      !_vm.showIfRisk
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "toMerge", type: "primary" },
                              on: { click: _vm.toMerge }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.combine")))]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_SMPartner_batchEditInvoiceHeader"
                      ]) && !_vm.showIfRisk
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "toEditInvoiceRiseByBatch",
                                type: "primary"
                              },
                              on: { click: _vm.toEditInvoiceRiseByBatch }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Partners.batchEditInvoiceHeader")
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["button_SMPartner_batchEditServer"])
                        ? _c(
                            "el-dropdown",
                            {
                              staticStyle: { margin: "0 5px" },
                              attrs: {
                                "split-button": "",
                                type: "primary",
                                no: "batchAddOrUpdateServicePerson"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.btnAddOrUpdateServiceHandle()
                                },
                                command: function(p) {
                                  _vm.btnAddOrUpdateService = p
                                  _vm.btnAddOrUpdateServiceHandle()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.btnAddOrUpdateService) + " "
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        no: "toAddServicePersonByBatch",
                                        command: _vm.$t(
                                          "Partners.batchAddServer"
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Partners.batchAddServer")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        no: "toEditServicePersonByBatch",
                                        command: _vm.$t(
                                          "Partners.batchEditServer"
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Partners.batchEditServer")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        no: "toEditEnterpriseWechatByBatch",
                                        command: _vm.$t(
                                          "CargoMsg.Cargo_BatchEditEnterpriseWechat"
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_BatchEditEnterpriseWechat"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.showIfRisk
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "btnInitTemplateClickHandler",
                                type: "primary"
                              },
                              on: { click: _vm.btnInitTemplateClickHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Partners.templateDownload"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["write_SMPartner"]) &&
                      !_vm.showIfRisk
                        ? _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "5px"
                              },
                              attrs: {
                                no: "upload",
                                action: _vm.actionUrl,
                                headers: { sessionId: _vm.sessionId },
                                "show-file-list": false,
                                accept: ".xls, .xlsx",
                                "before-upload": _vm.beforeUpload,
                                "on-success": _vm.uploadSuccess,
                                "on-error": _vm.uploadError
                              }
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { no: "import", type: "primary" } },
                                [_vm._v(_vm._s(_vm.$t("Partners.import")))]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["write_SMPartner"]) &&
                      !_vm.showIfRisk
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: {
                                no: "btnDownLoadResultHandler",
                                type: "primary"
                              },
                              on: { click: _vm.btnDownLoadResultHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Partners.downloadImportResults"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.serviceType ===
                        _vm.PartnerServiceItem.PARTNER_AGENT.code &&
                      _vm.$checkPermission(["button_SMPartner_exportAgents"])
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: {
                                no: "exportAgentsHandler",
                                type: "primary"
                              },
                              on: { click: _vm.exportAgentsHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.exportAgentList")))]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_SMPartner_openDownloadPartner"],
                              expression:
                                "['button_SMPartner_openDownloadPartner']"
                            }
                          ],
                          staticStyle: { "margin-left": "5px" },
                          attrs: {
                            no: "btnDownLoadPartnerHandler",
                            type: "primary"
                          },
                          on: { click: _vm.btnDownLoadPartnerHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.updateSupplierData")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_SMPartner_maintainControl"],
                              expression: "['button_SMPartner_maintainControl']"
                            }
                          ],
                          attrs: { no: "maintainControl", type: "primary" },
                          on: { click: _vm.maintainControl }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.maintainInformation")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_SMPartner_maintainControl"],
                              expression: "['button_SMPartner_maintainControl']"
                            }
                          ],
                          attrs: { no: "maintainBlacklist", type: "primary" },
                          on: { click: _vm.maintainBlacklist }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.batchBlacklistSetting"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: [
                                "button_SMPartner_maintainDefaultCreditInfo"
                              ],
                              expression:
                                "['button_SMPartner_maintainDefaultCreditInfo']"
                            }
                          ],
                          attrs: {
                            no: "maintainDefaultCreditInfo",
                            type: "primary"
                          },
                          on: { click: _vm.maintainDefaultCreditInfo }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.maintainDefaultCreditInfo"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wtOpenConfig && _vm.wtCreateCompany,
                              expression: "wtOpenConfig && wtCreateCompany"
                            }
                          ],
                          attrs: {
                            type: "primary",
                            no: "createWTCompanyHandler"
                          },
                          on: { click: _vm.createWTCompanyHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.credit_wtCreateCompany"))
                          )
                        ]
                      ),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wtOpenConfig && _vm.wtCreateCompany,
                            expression: "wtOpenConfig && wtCreateCompany"
                          }
                        ],
                        staticStyle: {
                          width: "20px",
                          height: "18px",
                          margin: "0 auto"
                        },
                        attrs: {
                          no: "certificationPartners",
                          src: "/static/info.png",
                          title: _vm.$t(
                            "Partners.addPlatformCertificationPartners"
                          )
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "template",
                { slot: "operations" },
                [
                  _vm.$checkPermission([
                    "button_SMPartner_newCustomerApplication"
                  ])
                    ? _c(
                        "el-button",
                        {
                          style: _vm.showPartnerButton
                            ? "margin-left: 5px"
                            : "",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.newCustomerApplication(true)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_NewCustomerApplication")
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.$checkPermission([
                    "button_SMPartner_newSupplierApplication"
                  ])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.newCustomerApplication(false)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_NewSupplierApplication")
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "101401",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "has-export-role": !_vm.isSalesForSzfs
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "101401",
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize,
                  total: _vm.searchConditions.total
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "form",
        {
          ref: "form",
          staticStyle: { display: "none" },
          attrs: { action: _vm.url, target: "_blank", method: "post" }
        },
        _vm._l(_vm.formEntries, function(item, index) {
          return _c("input", {
            key: index,
            attrs: { no: "url", name: item.name },
            domProps: { value: item.value }
          })
        }),
        0
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.priceLevelDialog.visible,
            title: _vm.$t("Partners.tariffLevelAuthorization"),
            width: "380px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.priceLevelDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "0px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "70px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Partners.fullContainerFreightRate")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "priceLevelFcl" },
                          model: {
                            value: _vm.priceLevelDialog.form.fcl,
                            callback: function($$v) {
                              _vm.$set(_vm.priceLevelDialog.form, "fcl", $$v)
                            },
                            expression: "priceLevelDialog.form.fcl"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Cost", value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: "Tier1", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "Tier2", value: 2 }
                          }),
                          _c("el-option", {
                            attrs: { label: "Tier3", value: 3 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.lclFreightRate") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "priceLevelLcl" },
                          model: {
                            value: _vm.priceLevelDialog.form.lcl,
                            callback: function($$v) {
                              _vm.$set(_vm.priceLevelDialog.form, "lcl", $$v)
                            },
                            expression: "priceLevelDialog.form.lcl"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Cost", value: 0 }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.PeerPrice"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.DirectPrice"),
                              value: 2
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.MarketPrice"),
                              value: 3
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.airFreightRate") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "priceLevelAir" },
                          model: {
                            value: _vm.priceLevelDialog.form.air,
                            callback: function($$v) {
                              _vm.$set(_vm.priceLevelDialog.form, "air", $$v)
                            },
                            expression: "priceLevelDialog.form.air"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Cost", value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: "Tier1", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "Tier2", value: 2 }
                          }),
                          _c("el-option", {
                            attrs: { label: "Tier3", value: 3 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.fbaRate") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "priceLevelFba" },
                          model: {
                            value: _vm.priceLevelDialog.form.fba,
                            callback: function($$v) {
                              _vm.$set(_vm.priceLevelDialog.form, "fba", $$v)
                            },
                            expression: "priceLevelDialog.form.fba"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Cost", value: 0 }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.PeerPrice"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.DirectPrice"),
                              value: 2
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.MarketPrice"),
                              value: 3
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("span", { staticStyle: { color: "#D2D2D2" } }, [
                    _vm._v(
                      "Tips: " +
                        _vm._s(_vm.$t("Partners.freightFateLevelIsAuthorized"))
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "executeGrantPriceLevel", type: "primary" },
                  on: { click: _vm.executeGrantPriceLevel }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "priceLevelCancel" },
                  on: {
                    click: function($event) {
                      _vm.priceLevelDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "mergeDialog",
          attrs: {
            visible: _vm.mergeDialog.visible,
            title: _vm.$t("Partners.mergePartners"),
            width: "950px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.mergeDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _vm._v(_vm._s(_vm.$t("Partners.parter")) + "：")
          ]),
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c("b", { staticStyle: { "font-size": "15px" } }, [
              _vm._v(_vm._s(_vm.mergeDialog.partnerName))
            ])
          ]),
          _c("merge-partner", {
            ref: "mergePartner",
            attrs: {
              "service-type": _vm.serviceType,
              "merge-to-cmp-idx": _vm.mergeDialog.cmpIdx
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "executeMerge", type: "primary" },
                  on: { click: _vm.executeMerge }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "visibleCancel" },
                  on: {
                    click: function($event) {
                      _vm.mergeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editInvoiceHeadVisible,
            title: _vm.$t("Partners.batchEditInvoiceHeader"),
            width: "950px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editInvoiceHeadVisible = $event
            }
          }
        },
        [
          _c("edit-invoice-head", {
            attrs: {
              "check-h-q-read-only-permission": function(rows) {
                return _vm.checkHQReadOnlyPermission(rows)
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editInvoiceHeadVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("edit-company-user", {
        attrs: {
          "check-h-q-read-only-permission": function(rows) {
            return _vm.checkHQReadOnlyPermission(rows)
          },
          visible: _vm.editCompanyUserVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.editCompanyUserVisible = $event
          },
          callback: _vm.updateRowData
        }
      }),
      _c("edit-partner-sale", {
        attrs: { visible: _vm.editPartnerSaleVisible },
        on: {
          "update:visible": function($event) {
            _vm.editPartnerSaleVisible = $event
          },
          callback: _vm.updateRowData
        }
      }),
      _c("w-t-application-list-window", {
        attrs: { visible: _vm.openSendList.visible },
        on: { visibleHandler: _vm.visibleHandler }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "maintainInformation",
          attrs: {
            visible: _vm.maintainCreditControl,
            title: _vm.$t("Partners.maintainInformation"),
            width: "950px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.maintainCreditControl = $event
            }
          }
        },
        [
          _c("i", { staticClass: "title-block-color" }),
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Partners.creditControlSettings")))
          ]),
          _c("div", { staticStyle: { "margin-top": "10px" } }, [
            _c(
              "div",
              { staticClass: "inner-row" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "form-item-350",
                    attrs: {
                      inline: true,
                      "label-width": "80px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "margin-Right50",
                        attrs: { label: _vm.$t("Partners.dateType") }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "remarks" },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          },
                          _vm._l(_vm.DATETYPE_TYPE, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.$getLangColumn(item),
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Invoice.invoice_settlementMethod")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { no: "val1" },
                                model: {
                                  value: _vm.creditDateTypeObj.val1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.creditDateTypeObj, "val1", $$v)
                                  },
                                  expression: "creditDateTypeObj.val1"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Partners.monthlySettlement"),
                                    value: -1
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_SettleByWeekly"
                                    ),
                                    value: -2
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_FixedDateMonthly"
                                    ),
                                    value: "n"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Partners.space5"),
                                    value: -3
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Partners.dailySettlement"),
                                    value: -4
                                  }
                                })
                              ],
                              1
                            ),
                            _c("el-input-number", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.creditDateTypeObj.val1 === "n",
                                  expression: "creditDateTypeObj.val1 === 'n' "
                                }
                              ],
                              attrs: {
                                no: "val2",
                                value: _vm.creditDateTypeObj.val2 || undefined,
                                min: 0,
                                precision: 0,
                                controls: false
                              },
                              on: {
                                input: function(val) {
                                  _vm.creditDateTypeObj.val2 = val
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c("br"),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "margin-Right50",
                        attrs: { label: _vm.$t("Partners.accountPeriod") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "300px" },
                              attrs: {
                                no: "creditDateLimited",
                                min: 0,
                                precision: 0,
                                "controls-position": "right"
                              },
                              model: {
                                value: _vm.form.creditDateLimited,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "creditDateLimited", $$v)
                                },
                                expression: "form.creditDateLimited"
                              }
                            }),
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  width: "200px",
                                  "margin-left": "5px"
                                },
                                attrs: { no: "termUnit" },
                                model: {
                                  value: _vm.form.termUnit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "termUnit", $$v)
                                  },
                                  expression: "form.termUnit"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Partners.day"),
                                    value: 0
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Partners.week"),
                                    value: 1
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Partners.month"),
                                    value: 2
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Partners.limit") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "300px" },
                              attrs: {
                                no: "credit",
                                min: 0,
                                precision: 0,
                                controls: false
                              },
                              model: {
                                value: _vm.form.credit,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "credit", $$v)
                                },
                                expression: "form.credit"
                              }
                            }),
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  "margin-left": "5px",
                                  width: "200px"
                                },
                                attrs: { no: "currency" },
                                model: {
                                  value: _vm.form.currency,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "currency", $$v)
                                  },
                                  expression: "form.currency"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "RMB", value: "RMB" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "USD", value: "USD" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inner-row" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": "80px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.settlementType") } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: {
                              no: "settlementType",
                              disabled: true,
                              value: _vm.settlementType
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { no: "byTicket", label: true } },
                              [_vm._v(_vm._s(_vm.$t("Message.ByTicket")))]
                            ),
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  no: "settlementNotByBill",
                                  label: false
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Partners.settlementNotByBill"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.remindShow,
                    expression: "remindShow"
                  }
                ],
                staticStyle: { color: "red" }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_Prompt")) +
                    "：" +
                    _vm._s(
                      _vm.$t("Partners.adjustContractInformationInBasicData")
                    )
                )
              ]
            )
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "creditControlSave", type: "primary" },
                  on: { click: _vm.creditControlSave }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "cancel" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "maintainBlacklistDialog",
          attrs: {
            visible: _vm.maintainBlacklistVisible,
            title: _vm.$t("Partners.batchBlacklistSetting"),
            width: "420px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.maintainBlacklistVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "90px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.blacklist") } },
                    [
                      _c("el-switch", {
                        attrs: { no: "batchBlacklistSwitch" },
                        model: {
                          value: _vm.blacklistForm.blacklist,
                          callback: function($$v) {
                            _vm.$set(_vm.blacklistForm, "blacklist", $$v)
                          },
                          expression: "blacklistForm.blacklist"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "batchBlacklistSave", type: "primary" },
                  on: { click: _vm.blacklistSave }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "batchBlacklistCancel" },
                  on: { click: _vm.blacklistCancel }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("default-credit-info-dialog", {
        attrs: { visible: _vm.maintainDefaultCreditControl },
        on: {
          "update:visible": function($event) {
            _vm.maintainDefaultCreditControl = $event
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.$t("Partners.addServicePersonnel"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "90px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.positionType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "roleType" },
                          on: { change: _vm.roleTypeChange },
                          model: {
                            value: _vm.editDialog.form.roleType,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "roleType", $$v)
                            },
                            expression: "editDialog.form.roleType"
                          }
                        },
                        _vm._l(_vm.roleTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.businessType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "lob" },
                          on: { change: _vm.lobChange },
                          model: {
                            value: _vm.editDialog.form.lob,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "lob", $$v)
                            },
                            expression: "editDialog.form.lob"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.All"),
                              value: "ALL"
                            }
                          }),
                          _vm._l(_vm.lobs, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCargoSource,
                          expression: "showCargoSource"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.SolicitationType") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "cargoSource", clearable: true },
                          model: {
                            value: _vm.editDialog.form.cargoSource,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "cargoSource", $$v)
                            },
                            expression: "editDialog.form.cargoSource"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.customerSpace2"),
                              value: "NC"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.customerSpace3"),
                              value: "SC"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.userName") } },
                    [
                      _c("cargo-user-select", {
                        ref: "userSelect",
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "userId",
                          "method-params": {
                            category: "role",
                            shape: _vm.getRoleTypeEnglishName(
                              _vm.editDialog.form.roleType
                            )
                          },
                          "default-value": _vm.editDialog.form.userId || "",
                          "show-custom-label-in-option": true,
                          "custom-label": _vm.userCustomLabel,
                          "init-default-option": true
                        },
                        on: {
                          change: function(p) {
                            _vm.editDialog.form.userId = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.isDefault") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "defaultUser" },
                          model: {
                            value: _vm.editDialog.form.defaultUser,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "defaultUser", $$v)
                            },
                            expression: "editDialog.form.defaultUser"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { no: "yes", label: true } },
                            [_vm._v(_vm._s(_vm.$t("Message.Yes")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { no: "no", label: false } },
                            [_vm._v(_vm._s(_vm.$t("Message.No")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks" },
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "saveSub", type: "primary" },
                  on: { click: _vm.btnAddServiceSaveHandle }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("edit-enterprise-wechat", {
        attrs: {
          "check-h-q-read-only-permission": function(rows) {
            return _vm.checkHQReadOnlyPermission(rows)
          },
          visible: _vm.editEnterpriseWechatVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.editEnterpriseWechatVisible = $event
          },
          callback: _vm.updateRowData
        }
      }),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: "PT",
              jobs: _vm.batchCheckingWindow.jobs,
              "batch-create-job": true,
              "append-to-body": true,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2,
              "close-callback": _vm.batchCheckingWindow.closeCallback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.companyApplyWindow.visible
        ? _c("company-apply-dialog", {
            ref: "companyApplyDialog",
            attrs: {
              visible: _vm.companyApplyWindow.visible,
              "company-bpm": _vm.companyApplyWindow.companyBpm,
              title: _vm.$t("CargoMsg.Cargo_PartnerApplicationApprovalProcess"),
              type: "apply"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.companyApplyWindow, "visible", $event)
              },
              close: function($event) {
                _vm.companyApplyWindow.visible = false
              },
              closeAndRefresh: _vm.closeAndRefresh
            }
          })
        : _vm._e(),
      _c("customer-application-dialog", {
        attrs: { visible: _vm.customerApplicationDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.customerApplicationDialogVisible = $event
          }
        }
      }),
      _c("supplier-application-dialog", {
        attrs: { visible: _vm.supplierApplicationDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.supplierApplicationDialogVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }